<template>
    <span>
        <el-button type="primary" size="mini" plain :loading="loading" @click="onSubmit" title="Migrate">
            Migrate
        </el-button>
    </span>
</template>

<script>
export default {
    props: {
        ingredientId: {
            required: true,
            type: String,
        },
        stepId: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    methods: {
        async onSubmit() {
            this.loading = true

            try {
                var { data } = await this.$http.put(`/recipe-ingredients/${ this.ingredientId }/migrate`, {
                    step_id: this.stepId,
                })
            } catch(err) {
                this.$message.error(err.response.data.message)

                return
            } finally {
                this.loading = false
            }

            this.$emit('update')
            this.$message.success(data.message)
        },
    },
}
</script>

<style>

</style>
